// extracted by mini-css-extract-plugin
export var downArrow = "_a9-0";
export var infoTooltipIcon = "_a9-3";
export var label = "_a9-1";
export var optionCard = "_a9-4";
export var upArrow = "_a9-2";